import * as api from '../api/exemptionReset';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'PROCESS-MANAGER';

export const FETCH_EXEMPTION_RESETS = createRequestTypes(
  `${prefix}/FETCH_EXEMPTION_RESETS`,
);

export const fetchExemptionResets = makeApiActionCreatorV3(
  api.fetchExemptionResets,
  FETCH_EXEMPTION_RESETS[START],
  FETCH_EXEMPTION_RESETS[SUCCESS],
  FETCH_EXEMPTION_RESETS[ERROR],
);

export const FETCH_EXEMPTION_RESET = createRequestTypes(
  `${prefix}/FETCH_EXEMPTION_RESET`,
);

export const fetchExemptionReset = makeApiActionCreatorV3(
  api.fetchExemptionReset,
  FETCH_EXEMPTION_RESET[START],
  FETCH_EXEMPTION_RESET[SUCCESS],
  FETCH_EXEMPTION_RESET[ERROR],
);

export const CREATE_EXEMPTION_RESET = createRequestTypes(
  `${prefix}/CREATE_EXEMPTION_RESET`,
);

export const createExemptionReset = makeApiActionCreatorV3(
  api.createExemptionReset,
  CREATE_EXEMPTION_RESET[START],
  CREATE_EXEMPTION_RESET[SUCCESS],
  CREATE_EXEMPTION_RESET[ERROR],
);

export const SELECT_EXEMPTION_RESET = createRequestTypes(
  `${prefix}/SELECT_EXEMPTION_RESET`,
);

export const selectExemptionReset = makeApiActionCreatorV3(
  api.selectExemptionReset,
  SELECT_EXEMPTION_RESET[START],
  SELECT_EXEMPTION_RESET[SUCCESS],
  SELECT_EXEMPTION_RESET[ERROR],
);

export const FETCH_EXEMPTION_RESET_SUMMARY_COUNTS = createRequestTypes(
  `${prefix}/FETCH_EXEMPTION_RESET_SUMMARY_COUNTS`,
);

export const fetchExemptionResetSummaryCounts = makeApiActionCreatorV3(
  api.fetchExemptionResetSummaryCounts,
  FETCH_EXEMPTION_RESET_SUMMARY_COUNTS[START],
  FETCH_EXEMPTION_RESET_SUMMARY_COUNTS[SUCCESS],
  FETCH_EXEMPTION_RESET_SUMMARY_COUNTS[ERROR],
);

export const FETCH_EXEMPTION_RESET_PROPERTY_LIST = createRequestTypes(
  `${prefix}/FETCH_EXEMPTION_RESET_PROPERTY_LIST`,
);

export const fetchExemptionResetPropertyList = makeApiActionCreatorV3(
  api.fetchExemptionResetPropertyList,
  FETCH_EXEMPTION_RESET_PROPERTY_LIST[START],
  FETCH_EXEMPTION_RESET_PROPERTY_LIST[SUCCESS],
  FETCH_EXEMPTION_RESET_PROPERTY_LIST[ERROR],
);

export const FETCH_EXEMPTION_RESET_LISTING = createRequestTypes(
  `${prefix}/FETCH_EXEMPTION_RESET_LISTING`,
);

export const fetchExemptionResetListing = makeApiActionCreatorV3(
  api.fetchExemptionResetListing,
  FETCH_EXEMPTION_RESET_LISTING[START],
  FETCH_EXEMPTION_RESET_LISTING[SUCCESS],
  FETCH_EXEMPTION_RESET_LISTING[ERROR],
);

export const FINALIZE_EXEMPTION_RESET = createRequestTypes(
  `${prefix}/FINALIZE_EXEMPTION_RESET`,
);

export const finalizeExemptionReset = makeApiActionCreatorV3(
  api.finalizeExemptionReset,
  FINALIZE_EXEMPTION_RESET[START],
  FINALIZE_EXEMPTION_RESET[SUCCESS],
  FINALIZE_EXEMPTION_RESET[ERROR],
);
